import { CSSObject } from '@emotion/react'
import { CSSProperties } from 'react'
import { sharedColors } from '../../../sharedStyles/styles'

export const accountWrapper: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  fontWeight: 'bold',
}

export const accountAvatar: CSSObject = {
  flexShrink: 0,
  marginRight: '8px',
  img: {
    height: '100%',
    objectFit: 'cover',
  },
}

export const collabAvatarSecondary: CSSObject = {
  ...accountAvatar,
  backgroundColor: 'rgb(208, 218, 225)',
  marginLeft: -8,
}

export const collabSeparator: CSSProperties = {
  color: sharedColors.white,
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 'normal',
  whiteSpace: 'pre',
}

export const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

export const nameRow: CSSObject = {
  alignItems: 'baseline',
  display: 'flex',
  [`&${withCollabSelector}`]: {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
  },
  [`&${withCollabSelector} .kuiper-account-name`]: {
    display: 'block',
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}

export const contentWrapper: CSSObject = {
  bottom: '0px',
  color: sharedColors.white,
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: '12px',
  position: 'absolute',
  rowGap: '12px',
  width: '300px',
  zIndex: 1000,
}

export const captionAndSoundWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',
}

export const postContentSound: CSSObject = {
  columnGap: '4px',
  display: 'flex',
  flexDirection: 'row',
  height: '26px',
  paddingLeft: '4px',
}

export const paidPromotion: CSSObject = {
  alignItems: 'center',
  backgroundColor: sharedColors.black + '50',
  borderRadius: '4px',
  columnGap: '10px',
  display: 'flex',
  flexDirection: 'row',
  fontSize: '12px',
  fontWeight: 'bold',
  height: '40px',
  justifyContent: 'center',
  width: '210px',
}

export const input = (readOnly: boolean): CSSObject => {
  const base = {
    backgroundColor: 'transparent',
    color: sharedColors.white,
    padding: 0,
    width: '100%',
  }

  const editable = {
    '&:hover': {
      backgroundColor: sharedColors.inputHover,
    },
  }

  return {
    ...base,
    ...(!readOnly ? editable : {}),
  }
}

export const captionInput = (readOnly: boolean): CSSObject => ({
  ...input(readOnly),
  maxHeight: '60px',
  width: 270,
  // Override default styles for `highlightSocialTags` prop
  '.social-link-match': {
    color: `${sharedColors.white} !important`,
    fontWeight: 'bold',
  },
})

export const soundInput = (readOnly: boolean): CSSObject => ({
  ...input(readOnly),
  maxHeight: 'max-content',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
})

export const inputPlaceholder: CSSObject = {
  color: sharedColors.white,
  opacity: 0.9,
}

export const iconsBar: CSSObject = {
  bottom: '0px',
  padding: '0 6px 15px 0',
  position: 'absolute',
  right: 0,
  width: '50px',
  zIndex: 1,
  '& > ul': {
    alignItems: 'center',
    color: sharedColors.white,
    display: 'flex',
    flexDirection: 'column',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    rowGap: '20px',
  },
}

export const iconBarItem: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px',
  rowGap: '8px',
}

export const soundIconWrapper: CSSObject = {
  backgroundColor: sharedColors.black + '80',
  border: `1px solid ${sharedColors.white}`,
  borderRadius: '6px',
  color: sharedColors.lightGray + '80',
  display: 'flex',
  height: '36px',
  justifyContent: 'center',
  width: '36px',
}

export const bottomGradient: CSSObject = {
  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%)`,
  bottom: '0',
  height: '120px',
  position: 'absolute',
  width: '375px',
  zIndex: 0,
}
